<span
  class="status"
  [ngClass]="statusDetails.classes"
  [matTooltip]="statusDetails.key"
>
  {{ statusDetails.label }}
</span>
